// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4546":"fedb608250dd340c","8560":"76d411bd2140a53c"}[chunkId] + ".css";
};